import React from "react";
var __jsx = React.createElement;
import { Link } from "react-router-dom";
import useHelpers from "@hooks/useHelpers";
import { useTranslation } from "@i18n";
var CarCountriesTags = function CarCountriesTags(_ref) {
  var className = _ref.className,
    filters = _ref.filters;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  var makeCountryFacet = filters === null || filters === void 0 ? void 0 : filters.find(function (facet) {
    return (facet === null || facet === void 0 ? void 0 : facet.filterField) === "make_country";
  });
  var countries = (makeCountryFacet === null || makeCountryFacet === void 0 ? void 0 : makeCountryFacet.values) || [];
  if (!countries.length) return null;
  return /*#__PURE__*/React.createElement("div", {
    id: "posts-seo-chips-car-countries",
    className: "flex flex-col gap-3 border-solid border-b border-[#e1e8f2] bg-white px-5 pt-4 pb-6 max-lg:px-0 max-lg:py-2 max-lg:rtl:pr-4 max-lg:ltr:pl-4 ".concat(className || "")
  }, /*#__PURE__*/React.createElement("strong", {
    id: "posts-seo-chips-car-countries-title",
    className: "text-[#154f9c] text-sm font-bold leading-6 m-hide"
  }, t("اختر بلد المنشأ", {
    ns: "web_search"
  })), /*#__PURE__*/React.createElement("div", {
    className: "relative"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex gap-2 overflow-y-auto w-full scroll-smooth transition-all duration-500 scrollbar-none"
  }, countries.map(function (country) {
    return /*#__PURE__*/React.createElement(Link, {
      id: "posts-seo-chip-country-".concat(country.slug),
      key: country.id,
      to: createUrl("/car-countries/".concat(country.slug)),
      className: "px-3 py-2 rounded-lg  border-solid border border-[#d7dce0] bg-white text-[#3c56d4] text-xs font-semibold leading-4 max-h-8 text-center whitespace-nowrap"
    }, country.name);
  }))));
};
export default CarCountriesTags;